import React from "react";
import { EsgSitesIcon } from "assets";
import { MRT_ColumnDef } from "material-react-table";
import { formatToUSNumber, getFormattedDate } from "utils";
import { RenewableEnergyPurchasesDTO } from "api";
import { Box } from "@mui/material";

export const SITES_PAGE = {
  ABSOLUTE_PATH: "/sites",
  TITLE: "Site management",
  ICON: <EsgSitesIcon />,
  IS_TBD: false,
  renderMenu: false,
};

export const RENEWABLE_ENERGY_PURCHASES: MRT_ColumnDef<RenewableEnergyPurchasesDTO>[] = [
  {
    header: "Geography",
    accessorKey: "geography",
    Cell: ({ row }: { row: any }) => {
      const { geography } = row.original;
      return (
        <Box sx={{
          display: "flex",
          alignItems: "center",
          height: "84px",
          padding: "12px 16px",
        }}>
          <p style={{
            fontFamily: 'Inter',
            fontWeight: '400',
            fontSize: '14px',
          }}>
            {geography}
          </p>
        </Box>
      );
    },
    size: 120,
  },
  {
    header: "Total Renewable Energy Amount",
    accessorKey: "totalRenewableEnergy",
    Cell: ({ row }: { row: any }) => {
      const { totalRenewableEnergy, renewableEnergyUnit } = row.original;
      return (
        <Box sx={{
          display: "flex",
          alignItems: "center",
          height: "84px",
          padding: "12px 16px",
        }}>
          <p style={{
            fontFamily: 'Inter',
            fontWeight: '400',
            fontSize: '14px',
          }}>
            {formatToUSNumber(totalRenewableEnergy)} {renewableEnergyUnit}
          </p>
        </Box>
      );
    },
    size: 240,
  },
  {
    header: "Start Date",
    accessorKey: "startDate",
    Cell: ({ row }: { row: any }) => {
      const { startDate } = row.original;
      return (
        <Box sx={{
          display: "flex",
          alignItems: "center",
          height: "84px",
          padding: "12px 16px",
        }}>
          <p style={{
            fontFamily: 'Inter',
            fontWeight: '400',
            fontSize: '14px',
          }}>
            {getFormattedDate(startDate, '/')}
          </p>
        </Box>
      );
    },
    size: 120,
  },
  {
    header: "End Date",
    accessorKey: "endDate",
    Cell: ({ row }: { row: any }) => {
      const { endDate } = row.original;
      return (
        <Box sx={{
          display: "flex",
          alignItems: "center",
          height: "84px",
          padding: "12px 16px",
        }}>
          <p style={{
            fontFamily: 'Inter',
            fontWeight: '400',
            fontSize: '14px',
          }}>
            {getFormattedDate(endDate, '/')}
          </p>
        </Box>
      );
    },
    size: 120,
  },
];